import { Icon } from '@seeqdev/qomponents';
import clsx from 'clsx';
import { ContainerWithHTML } from '@/core/ContainerWithHTML.atom';

export const spinner = (message: string | null = null, extraClassNames: string | null = null) => (
  <div
    data-testid="loadingSpinner"
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
    }}>
    <Icon
      icon="fa-spinner"
      iconPrefix="fa-solid"
      extraClassNames={clsx('fa-spin fa-pulse correctSpin', extraClassNames)}
    />
    {message ? (
      <div style={{ paddingTop: '0.3em', fontFamily: 'sans-serif' }}>
        <p>{message}</p>
      </div>
    ) : null}
  </div>
);

export const error = (message: string | null = null, extraClassNames: string | null = null) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
    }}>
    <Icon icon="fa-triangle-exclamation" extraClassNames={clsx(extraClassNames)} />
    {message ? (
      <div style={{ paddingTop: '0.3em', fontFamily: 'sans-serif', textAlign: 'center' }}>
        <ContainerWithHTML content={message} isBlock={false} />
      </div>
    ) : null}
  </div>
);
